import { Component, Input, OnInit, OnDestroy, ElementRef } from '@angular/core';

import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { HelpContentService } from '../core/help-content.service';
import { HelpService } from '../core/help.service';

import { HelpContentState } from '../core/help.models';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-help-inline',
  standalone: false,
  templateUrl: './help-inline.component.html',
  styleUrl: './help-inline.component.scss',
})
export class HelpInlineComponent implements OnInit, OnDestroy {
  faInfoCircle = faInfoCircle;

  @Input() helpKey!: string;

  // * Anchor ID (set by directive in directive mode)
  @Input() anchorId?: string;

  contentState$?: Observable<HelpContentState>;

  expanded = false;

  private isDeclarative = false;

  constructor(
    private elementRef: ElementRef,
    private helpContentService: HelpContentService,
    private helpService: HelpService,
  ) {}

  ngOnInit(): void {
    if (!this.helpKey) {
      console.warn('HelpInlineComponent: helpKey is required');
      return;
    }

    // * if no anchorId, we're in declarative mode - register self
    if (!this.anchorId) {
      this.isDeclarative = true;
      this.anchorId = this.helpService.registerAnchor(this.elementRef, {
        key: this.helpKey,
        mode: 'inline',
      });
    }
  }

  ngOnDestroy(): void {
    // * only unregister if we registered it (declarative mode)
    if (this.isDeclarative && this.anchorId) {
      this.helpService.unregisterAnchor(this.anchorId);
    }
  }

  toggleExpand(): void {
    this.expanded = !this.expanded;

    // * lazy load content on first expand
    if (this.expanded && !this.contentState$) {
      this.contentState$ = this.helpContentService.getContent(this.helpKey);
    }
  }
}
